import { render, staticRenderFns } from "./ShipHead.vue?vue&type=template&id=6360581b&"
import script from "./ShipHead.vue?vue&type=script&setup=true&lang=js&"
export * from "./ShipHead.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ShipHead.vue?vue&type=style&index=0&id=6360581b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports